import Accordion from './Accordion'
import DataBlock from './DataBlock'
import DataInfo from './DataInfo'
import { getIsValidQualification } from './helpers/data-validation'

import type { IBCKSKepalaSekolahEligibility } from 'types/bcks'
import type { FC } from 'react'

interface BlockQualificationProps {
  data: IBCKSKepalaSekolahEligibility['qualification']
}

const BlockQualification: FC<BlockQualificationProps> = ({ data }) => {
  return (
    <Accordion
      title="Kualifikasi & Kepegawaian"
      isError={!getIsValidQualification(data)}
    >
      <div className="space-y-4">
        <DataBlock
          label="Kualifikasi Akademik"
          errorMessage={data?.kualifikasiAkademik.validation}
        >
          {data?.kualifikasiAkademik.value}
        </DataBlock>
        <DataBlock
          label="Status Kepegawaian"
          errorMessage={data?.statusKepegawaian.validation}
        >
          {data?.statusKepegawaian.value}
        </DataBlock>
        {data?.statusKepegawaian.value === 'PNS' && (
          <DataBlock
            label="Pangkat/Golongan"
            errorMessage={data?.pangkatGolongan.validation}
          >
            {data?.pangkatGolongan.value}
          </DataBlock>
        )}

        <DataInfo />
      </div>
    </Accordion>
  )
}
export default BlockQualification
